import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { ConfigService } from './config-service.service';

export interface Product {
  name: String;
  description: String;
  brochureLink: String;
  url: String;
  productIcon: String;
  aboutImg: String;
  mockup: boolean;
  staticImage: String;
  routerLink: String;
  hideIfMissing: Boolean;
}

@Injectable({
  providedIn: "root",
})
export class ProductService {
  private products: Product[] = [];
  public productPermissionPrefixes: { label: string, value: string; }[];

  constructor(
    public authService: AuthService,
    private config: ConfigService
  ) {
    const environment = this.config.getJson();
    this.products = [
      {
        name: "ACSIS",
        url: environment.productURL.acsis,
        description: "A powerful predictive maintenance tool for the aviation industry.",
        brochureLink: "https://jetbridge-dev-public-files.s3.us-west-2.amazonaws.com/CC_ACSIS_brochure_20220126.pdf",
        productIcon: "../global/images/crossconsense.png",
        aboutImg: "../global/images/crossconsense-device-mockup.png",
        mockup: false,
        staticImage: '',
        routerLink: '',
        hideIfMissing: false
      },
      {
        name: "AFIRS Gateway",
        url: environment.productURL.afirsAnalytics,
        description: "A portal to manage your AFIRS device health and data.",
        brochureLink: "https://jetbridge-dev-public-files.s3.us-west-2.amazonaws.com/FLYHT_AFIRS_228_Voice_and_Data_Comms+Solution.pdf",
        productIcon: "../global/images/afirs.png",
        aboutImg: "../global/images/afirs-analytics-device-mockup.png",
        mockup: false,
        staticImage: '../global/images/afirs-analytics-static-image.png',
        routerLink: '/afirs-analytics',
        hideIfMissing: false
      },
      {
        name: "Aircraft Fleet View",
        url: environment.productURL.aircraftFleetView,
        description: "Gives you an up-to-the-minute view on your airline’s fleet status.",
        brochureLink: "https://jetbridge-dev-public-files.s3.us-west-2.amazonaws.com/CC_AFV_brochure_20220126.pdf",
        productIcon: "../global/images/crossconsense.png",
        aboutImg: "../global/images/crossconsense-device-mockup.png",
        mockup: false,
        staticImage: '',
        routerLink: '',
        hideIfMissing: false
      },
      {
        name: "AviationDW",
        url: environment.productURL.aviationDW,
        description: "A managed data warehouse, tailor-made for use with your backend maintenance control system.",
        brochureLink: "https://jetbridge-dev-public-files.s3.us-west-2.amazonaws.com/CC_Aviation_DW_brochure_20220126.pdf",
        productIcon: "../global/images/crossconsense.png",
        aboutImg: "../global/images/crossconsense-device-mockup.png",
        mockup: false,
        staticImage: '',
        routerLink: '',
        hideIfMissing: false
      },
      {
        name: "ClearPort",
        url: environment.productURL.clearPort,
        description: "Clear window into your turn process.",
        brochureLink: "https://jetbridge-dev-public-files.s3.us-west-2.amazonaws.com/ClearPort_2022.pdf",
        productIcon: "../global/images/airport-tower.png",
        aboutImg: "../global/images/clearport-device-mockup.png",
        mockup: false,
        staticImage: '../global/images/clear-port-static-image.png',
        routerLink: '/clear-port',
        hideIfMissing: false
      },
      {
        name: "FleetWatch",
        url: environment.productURL.fleetWatch,
        description: "Flight following and GADS ICAO compliance.",
        brochureLink: "https://jetbridge-dev-public-files.s3.us-west-2.amazonaws.com/Fleetwatch_2022.pdf",
        productIcon: "../global/images/fleet.png",
        aboutImg: "../global/images/fleetwatch-device-mockup.png",
        mockup: false,
        staticImage: '',
        routerLink: '',
        hideIfMissing: false
      },
      {
        name: "FuelSense",
        url: environment.productURL.fuelSense,
        description: "Safe and actionable fuel efficience.",
        brochureLink: "https://jetbridge-dev-public-files.s3.us-west-2.amazonaws.com/FLYHT_FuelSense2022.pdf",
        productIcon: "../global/images/fuel.png",
        aboutImg: "../global/images/fuelsense-device-mockup.png",
        mockup: false,
        staticImage: '',
        routerLink: '',
        hideIfMissing: false
      },
      {
        name: "AircraftSim",
        url: environment.productURL.aircraftSim,
        description: "Connect to the aircraft edge simulator.",
        brochureLink: "",
        productIcon: "../global/images/passenger-airplane-on-a-black-background-hand-vector-24605750.svg",
        aboutImg: "",
        mockup: false,
        staticImage: '',
        routerLink: '',
        hideIfMissing: true
      },
    ];

    this.productPermissionPrefixes = [
      { value: "ClearPort", label: "ClearPort" },
      { value: "JetBridge", label: "JetBridge" },
      { value: "AircraftSim", label: "AircraftSim" },
      { value: "FleetWatch", label: "FleetWatch" },
      { value: "FuelSense", label: "FuelSense" },
      { value: "AfirsAnalytics", label: "AFIRS Gateway" },
      { value: "AfirsConnect", label: "AFIRS Connect" }
    ];
  }

  getProducts(all: boolean = false) {
    if (all) return this.products;

    const userProducts = this.authService.user.products;

    return this.products.filter((product) => !product.hideIfMissing || userProducts.includes(product.name));
  }
}
